import { WebStorageStateStore } from 'oidc-client-ts'
import type { AuthProviderProps } from 'react-oidc-context'
import { config } from './config'

/**
 * OIDC settings for the Authorization-Code + PKCE flow against zmidentity
 * (hemagg tenant). The SPA holds no secret; PKCE protects the code exchange.
 */
export const oidcConfig: AuthProviderProps = {
  authority: config.oidcAuthority,
  client_id: config.oidcClientId,
  redirect_uri: `${window.location.origin}/auth/callback`,
  post_logout_redirect_uri: window.location.origin,
  response_type: 'code',
  scope: config.oidcScope,
  // Refresh tokens via silent renew where the IdP issues them.
  automaticSilentRenew: true,
  loadUserInfo: true,
  userStore: new WebStorageStateStore({ store: window.localStorage }),
  // Strip the ?code&state params from the URL after a successful login.
  onSigninCallback: () => {
    window.history.replaceState({}, document.title, window.location.pathname)
  },
}
